import "./Impact.scss";
import Accordion from "react-bootstrap/Accordion";
import physicalimpacticon1 from "../../../assets/images/physicalimpacticon1.png";
import physicalimpacticon2 from "../../../assets/images/physicalimpacticon2.png";
import socialimpacticon1 from "../../../assets/images/socialimpacticon1.png";
import socialimpacticon2 from "../../../assets/images/socialimpacticon2.png";
import socialimpacticon3 from "../../../assets/images/socialimpacticon3.png";
import economicimpacticon1 from "../../../assets/images/economicimpacticon1.png";
import economicimpacticon2 from "../../../assets/images/economicimpacticon2.png";
import economicimpacticon3 from "../../../assets/images/economicimpacticon3.png";
import { useEffect } from "react";
import * as $ from "jquery";
import IconTabs from "./IconTabs";
const Impact = () => {
  return (
    <section>
      <div className="container">
        <Accordion defaultActiveKey="" className="mobile">
          <Accordion.Item eventKey="0">
            <Accordion.Header>Physical Impact</Accordion.Header>
            <Accordion.Body>
              <div className="impact-row">
                <div className="custom-row">
                  <img
                    alt="physical-impact"
                    src={physicalimpacticon1}
                    className="impact-icon"
                  />
                  <div className="impact-title">Inundated Area</div>
                </div>
                <div className="impact-description">
                  <div>
                    <b>Across 14 out of 20 LGAs</b> with Eti-Osa,
                    Ajeromi/Ifelodun &amp; Kosofe as top 3 area
                  </div>
                  <div className="digit">
                    <b>165</b>
                    <span>
                      &nbsp;km<sup>2</sup>
                    </span>
                  </div>
                </div>
              </div>
              <div className="impact-row">
                <div className="custom-row">
                  <img
                    alt="physical-impact"
                    src={physicalimpacticon2}
                    className="impact-icon"
                  />
                  <div className="impact-title">Natual Ecosystems</div>
                </div>
                <div className="impact-description">
                  <div>
                    Of wetlands affected with potential loss in{" "}
                    <b>biodiversity &amp; ecosystem services</b>
                  </div>
                  <div className="digit">
                    <span>
                      <b>82</b>
                      <span>%</span>
                    </span>
                  </div>
                </div>
                <br />
                <div className="impact-description">
                  <div>
                    <b>
                      Loss of water height in waterbodies due to evaporation
                    </b>{" "}
                    leading to a loss of natural cooling systems
                  </div>
                  <div className="digit">
                    <span>
                      <b>0.7</b>
                      <span>m</span>
                    </span>
                  </div>
                </div>
              </div>
              <div className="physical-impact-greybox">
                <div>SLR scenario: 2050- SSP-2.45 – EE (1/10)</div>
                <div>Extreme heat scenario: 2050- RCP 4.5</div>
              </div>
            </Accordion.Body>
          </Accordion.Item>
          <Accordion.Item eventKey="2">
            <Accordion.Header>Social Impact</Accordion.Header>
            <Accordion.Body>
              <div className="impact-row">
                <div className="custom-row">
                  <img
                    alt="physical-impact"
                    src={socialimpacticon1}
                    className="impact-icon"
                  />
                  <div className="impact-title">
                    Vulnerable Population<sup>1</sup>
                  </div>
                </div>
                <div className="impact-description">
                  <div>
                    People inundated across most LGAs including{" "}
                    <b>+350k women</b>
                  </div>
                  <div className="digit">
                    <span>
                      <b>&gt;1.4</b>
                      <span>M</span>
                    </span>
                  </div>
                </div>
                <div className="impact-description">
                  <div>Additional people under the poverty line</div>
                  <div className="digit">
                    <span>
                      <b>+53</b>
                      <span>K</span>
                    </span>
                  </div>
                </div>
              </div>
              <div className="impact-row">
                <div className="custom-row">
                  <img
                    alt="physical-impact"
                    src={socialimpacticon3}
                    className="impact-icon"
                  />
                  <div className="impact-title">Health</div>
                </div>
                <div className="impact-description">
                  <div>
                    Heat-related death of which <b>30% are children</b>
                  </div>
                  <div className="digit">
                    <span>
                      <b>+20</b>
                      <span>K</span>
                    </span>
                  </div>
                </div>
                <br />
                <div className="impact-description">
                  <div>
                    <b>Increase in food import dependency</b> due to loss of
                    local yield crops
                  </div>
                  <div className="digit">
                    <span>
                      <b>5</b>
                      <span>%</span>
                    </span>
                  </div>
                </div>
              </div>
              <div className="impact-row">
                <div className="custom-row">
                  <img
                    alt="physical-impact"
                    src={socialimpacticon2}
                    className="impact-icon"
                  />
                  <div className="impact-title">Social Infrastructure</div>
                </div>
                <div className="impact-description">
                  <div>
                    Health centers disrupted{" "}
                    <b>
                      affecting +2m patients<sup>2</sup>
                    </b>
                  </div>
                  <div className="digit">
                    <span>
                      <b>&gt;400</b>
                    </span>
                  </div>
                </div>
                <br />
                <div className="impact-description">
                  <div>
                    Education centers inundated{" "}
                    <b>
                      limiting school access to more than 500k<sup>3</sup>{" "}
                      students
                    </b>
                  </div>
                  <div className="digit">
                    <span>
                      <b>&gt;500</b>
                    </span>
                  </div>
                </div>

                <div className="impact-points">
                  <b>1.</b> All gender, all age groups, poor to extremely poor
                  <br />
                  <b>2.</b> 5k patients per health center
                  <br />
                  <b>3.</b> 1k students per education center
                </div>
              </div>
            </Accordion.Body>
          </Accordion.Item>
          <Accordion.Item eventKey="3">
            <Accordion.Header>Economic Impact</Accordion.Header>
            <Accordion.Body>
              <div className="impact-row">
                <div className="custom-row">
                  <img
                    alt="physical-impact"
                    src={economicimpacticon1}
                    className="impact-icon"
                  />
                  <div className="impact-title">Damage To Infrastructures</div>
                </div>
                <div className="impact-description">
                  <div>
                    Incl. impact <b>severe disruptions to critical systems</b>{" "}
                    already under stress in a context of rapid urbanization
                    <br />
                    <br />
                    &bull;<b>11%</b> of the transportation network<sup>1</sup>
                    <br />
                    &bull;<b>12%</b> of the power grid
                    <br />
                    &bull;<b>13%</b> of communication network
                    <br />
                  </div>
                  <div className="digit">
                    <span>
                      <b>$5</b>
                      <span>bn</span>
                    </span>
                  </div>
                </div>
              </div>
              <div className="impact-row">
                <div className="custom-row">
                  <img
                    alt="physical-impact"
                    src={economicimpacticon2}
                    className="impact-icon"
                  />
                  <div className="impact-title">
                    Cost of Relocation<sup>2</sup>
                  </div>
                </div>
                <div className="impact-description">
                  <div>
                    Relocation of{" "}
                    <b>+700k people living in permanently flooded areas</b>
                  </div>
                  <div className="digit">
                    <span>
                      <b>$6</b>
                      <span>bn</span>
                    </span>
                  </div>
                </div>
                <br />
              </div>
              <div className="impact-row">
                <div className="custom-row">
                  <img
                    alt="physical-impact"
                    src={economicimpacticon3}
                    className="impact-icon"
                  />
                  <div className="impact-title">Annual GDP Loss</div>
                </div>
                <div className="impact-description">
                  <div>
                    <b>GDP loss from disruption of economic activities</b> in
                    inundated regions
                  </div>
                  <div className="digit">
                    <span>
                      <b>$17</b>
                      <span>bn</span>
                    </span>
                  </div>
                </div>
                <br />
                <div className="impact-description">
                  <div>
                    <b>
                      GDP loss from 44 additional unproductive days and yield
                      loss
                    </b>{" "}
                    due to extreme temperature
                  </div>
                  <div className="digit">
                    <span>
                      <b>$5</b>
                      <span>bn</span>
                    </span>
                  </div>
                </div>
                <div className="impact-points">
                  <b>1.</b> Including airports, ports, jetties, roads and rails
                  <br />
                  <b>2.</b> One-off cost of relocation in 2030 ($40k/household
                  of 5 people)
                </div>
              </div>
            </Accordion.Body>
          </Accordion.Item>
        </Accordion>
        <IconTabs />
      </div>
    </section>
  );
};

export default Impact;
